module.exports = __webpack_public_path__ + "img/buitl-w-rivet-v2.16fce99c.svg";